module.exports = __webpack_public_path__ + "static/media/chapter-next-button.f54f2ede.svg";